import { validateUpload } from './sanitizeFilename';

/** Keep the native picker and submission validation on the same extension list. */
export const DELIVERABLE_FILE_ACCEPT = '.pdf,.doc,.docx,.ppt,.pptx,.zip,.xls,.xlsx,.png,.jpg,.jpeg,.md,.txt,.json';

export function validateDeliverableUpload(file: File) {
  const result = validateUpload(file);
  if (!result.ok) return result;
  const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  if (!DELIVERABLE_FILE_ACCEPT.split(',').includes(extension)) {
    return { ok: false as const, error: 'Formato no permitido. Para HTML o código, utiliza un ZIP o un enlace.' };
  }
  return result;
}